import classNames from 'classnames';
import { useRef } from 'react';
import useOnScreen from '@/helpers/useOnScreen';
import styles from '@/styles/personae.module.scss';
import { CodePreview } from '@/components/global';
import { Button, Icon } from '@/components/standalone';

const codeBlock = `
<head>
  <script src="https://widget.trustblock.run/auditor-widget.min.js" defer></script>
</head>
<body>
  <div
    data-tb-auditor-widget
    data-tb-auditor-slug="cyberscope"
    data-tb-text-color="#000000"
    data-tb-bg-color="#edecee"
    data-tb-accent-color="#751dff"
  />
</body>
`;

function AuditorsWidgetSection() {
  const headingRef = useRef();
  const { isOnScreen: isHeadingOnScreen } = useOnScreen({
    ref: headingRef,
    threshold: 0.3,
    rootMargin: '0px',
    isOnce: true,
  });

  const contentRef = useRef();
  const { isOnScreen: isContentOnScreen } = useOnScreen({
    ref: contentRef,
    threshold: 0.3,
    rootMargin: '0px',
    isOnce: true,
  });

  return (
    <div
      className={classNames(
        'section',
        styles.personaeSection,
        styles.personaeSectionCenter,
        styles.personaeSectionGrey,
      )}
    >
      <div className={classNames('max-content-width', styles.classic)}>
        <div
          className={classNames(styles.personaeSectionText, {
            [styles.personaeSectionTextAppear]: isHeadingOnScreen,
          })}
          ref={headingRef}
        >
          <div className="tb-tag dark">
            <Icon name="Code" />
            USE OUR WIDGET
          </div>
          <h2>Display real metrics on your website</h2>
          <p>
            Integrate our metrics on your website widget in no time & show the
            world what your firm has accomplished.
          </p>
        </div>

        <div
          className={classNames(styles.personaeSectionContent, {
            [styles.personaeSectionContentAppear]: isContentOnScreen,
          })}
          ref={contentRef}
        >
          <CodePreview codeBlock={codeBlock}>
            <div
              data-tb-auditor-widget
              data-tb-auditor-slug="cyberscope"
              data-tb-text-color="#000000"
              data-tb-bg-color="#edecee"
              data-tb-accent-color="#751dff"
            />
          </CodePreview>
          <Button
            type="link"
            href={`${process.env.NEXT_PUBLIC_WEB_URL}/widget/auditor?slug=cyberscope&textColor=%23000000&backgroundColor=%23edecee&accentColor=%23751dff`}
            icon="ArrowUpRight"
            mode="primary"
          >
            Try it on our playground
          </Button>
        </div>
      </div>
    </div>
  );
}

export default AuditorsWidgetSection;
